<template>
    <div class="content-body tenant-settings">
        绩效管理（暂时不处理，敬请期待）
        <!-- <el-form :inline="true" :model="dataForm" @keyup.enter.native="listTenants()">
            <el-form-item label="流程编码:">
                <el-input size="small" v-model="dataForm.code" placeholder="流程编码" clearable></el-input>
            </el-form-item>
            <el-form-item label="流程名称:">
                <el-input size="small" v-model="dataForm.name" placeholder="流程名称" clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button size="small" @click="listProcess()" icon="el-icon-search">查询
                </el-button>
                <el-button size="small" v-if="isAuth('sys:tenant:save')" type="primary" @click="addOrUpdateHandle()"
                           icon="el-icon-plus">新增
                </el-button>
            </el-form-item>
        </el-form>
        <el-table
                :data="dataList"
                v-loading="dataListLoading"
                size="small"
                border
                stripe
                @selection-change="selectionChangeHandle"
                :height="documentClientHeight"
                style="width: 100%;">
            <el-table-column
                    type="selection"
                    header-align="center"
                    align="center"
                    width="50">
            </el-table-column>
            <el-table-column
                    prop="key"
                    header-align="left"
                    align="left"
                    label="流程编码">
            </el-table-column>
            <el-table-column
                    prop="name"
                    header-align="left"
                    align="left"
                    label="流程名称">
            </el-table-column>
            <el-table-column
                    prop="category"
                    header-align="left"
                    align="left"
                    label="分类">
            </el-table-column>
            <el-table-column
                    prop="version"
                    header-align="left"
                    align="left"
                    label="版本">
            </el-table-column>
            <el-table-column
                    prop="status"
                    header-align="left"
                    align="left"
                    label="状态">
                <template slot-scope="scope">
                    <el-tag size="small" type="success">{{scope.row.status}}</el-tag>
                </template>
            </el-table-column>
            <el-table-column
                    prop="pic"
                    header-align="left"
                    align="left"
                    label="流程图">
                <template slot-scope="scope">
                    <el-link type="primary" style="font-size: 12px;" @click="viewDiagram(scope.row.id)"><i class="el-icon-view" style="margin-right: 5px;"></i>查看</el-link>
                </template>
            </el-table-column>
            <el-table-column
                    header-align="left"
                    align="left"
                    width="300"
                    label="操作">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="setNodes(scope.row.id, scope.row.key)" icon="el-icon-tools">配置节点</el-button>
                    <el-button type="text" size="small" @click="addOrUpdateHandle(scope.row.id)" icon="el-icon-edit">修改
                    </el-button>
                    <el-button type="text" size="small" @click="deleteHandle(scope.row.id)" icon="el-icon-delete">删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
                @size-change="sizeChangeHandle"
                @current-change="currentChangeHandle"
                :current-page="pageIndex"
                :page-sizes="[10, 20, 50]"
                :page-size="pageSize"
                :total="totalPage"
                layout="total, sizes, prev, pager, next, jumper">
        </el-pagination> -->
        <!-- 弹窗, 新增 / 修改 -->
        <!-- <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="listProcess"></add-or-update>
        <task-nodes-update v-if="nodesUpdateVisible" ref="taskNodesUpdate" @refreshDataList="listProcess"></task-nodes-update>
        <el-dialog
                :visible.sync="showViewer"
                width="80%"
                title="流程图">
            <el-image :src="diagramUrl" style="margin-bottom: 120px;">
            </el-image>
        </el-dialog> -->
    </div>
</template>

<script>
    // import {listProcessDefinitions, getProcessDiagram} from '@/controller/workflow'
    // import AddOrUpdate from './flow-add-or-update'
    // import TaskNodesUpdate from './task-nodes-update'

    export default {
        data() {
            return {
                documentClientHeight: document.documentElement['clientHeight'] - 250,
                dataForm: {
                    code: '',
                    name: ''
                },
                dataList: [],
                pageIndex: 1,
                pageSize: 10,
                totalPage: 0,
                dataListLoading: false,
                dataListSelections: [],
                addOrUpdateVisible: false,
                nodesUpdateVisible: false,
                showViewer: false,
                diagramUrl: ''
            }
        },
        // components: {
        //     AddOrUpdate,
        //     TaskNodesUpdate
        // },
        // activated() {
        //     this.listProcess()
        // },
        // methods: {
        //     setNodes(id, key){
        //         this.nodesUpdateVisible = true
        //         this.$nextTick(() => {
        //             this.$refs.taskNodesUpdate.init(id, key)
        //         })
        //     },
        //     closeViewer(){
        //         this.showViewer = false
        //     },
        //     viewDiagram(id) {
        //         getProcessDiagram({id: id}).then(data => {
        //             this.diagramUrl = data.body
        //             this.showViewer = true
        //         })
        //     },
        //     // 获取数据列表
        //     listProcess() {
        //         listProcessDefinitions().then(data => {
        //             this.dataList = data.body.records
        //             this.totalPage = data.body.total
        //         })
        //     },
        //     // 每页数
        //     sizeChangeHandle(val) {
        //         this.pageSize = val
        //         this.pageIndex = 1
        //         this.listTenants()
        //     },
        //     // 当前页
        //     currentChangeHandle(val) {
        //         this.pageIndex = val
        //         this.listTenants()
        //     },
        //     // 多选
        //     selectionChangeHandle(val) {
        //         this.dataListSelections = val
        //     },
        //     // 新增 / 修改
        //     addOrUpdateHandle(id) {
        //         this.addOrUpdateVisible = true
        //         this.$nextTick(() => {
        //             this.$refs.addOrUpdate.init(id)
        //         })
        //     },
        //     menuUpdateHandle(id) {
        //         this.menuUpdateVisible = true
        //         this.$nextTick(() => {
        //             this.$refs.menuUpdate.init(id)
        //         })
        //     },
        //     // 删除
        //     deleteHandle(id) {
        //         // TODO
        //         console.log(id)
        //     }
        // }
    }
</script>